import * as React from "react";
import { fetchShortcodeSummary } from "../../../Api/Shortcode/ShortcodeApi";
import { useEffect, useState } from "react";
import { ApplicationContext } from "../../../ApplicationContext";
import { isRequestError } from "../../../Model/RequestError";
import { useSearchParams } from "react-router-dom";
import { ShortcodeSummary } from "../../../Model/Shortcode/ShortcodeSummary";

interface ShortcodeSearchProps {
    onSearch: (shortcodeSummary: ShortcodeSummary | undefined) => void
}

const ShortcodeSearch = (props: ShortcodeSearchProps): JSX.Element => {
    const applicationContext = React.useContext(ApplicationContext)
    const [searchParams, setSearchParams] = useSearchParams();

    const [shortcode, setShortcode] = useState("")
    const [shortcodeError, setShortcodeError] = useState(" ")

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        handleSearch(shortcode)
    }

    const handleSearch = async (shortcode: string) => {
        const result = await fetchShortcodeSummary(applicationContext.salesPortalApiDomain, shortcode)
        setSearchParams({ shortcode })
        if (isRequestError(result)) {
            switch (result.status) {
                case 404:
                    setShortcodeError("Shortcode not found")
                    break
                default:
                    setShortcodeError("We are unable to return details for your shortcode at the moment")
                    break
            }
            props.onSearch(undefined)
        } else {
            props.onSearch(result);
        }
    }

    useEffect(() => {
        const shortcodeQueryParam = searchParams.get("shortcode") || "";
        setShortcode(shortcodeQueryParam);

        if (shortcodeQueryParam) {
            handleSearch(shortcodeQueryParam);
        }
    }, []);

    useEffect(() => {
        setShortcodeError(" ")
    }, [shortcode]);

    return <>
        <form onSubmit={handleSubmit}>
            <div className="form-group shortcode-input-container">
                <label htmlFor="shortcode">
                    Enter the shortcode number to find out charges
                </label>
                <input
                    type="text"
                    id="shortcode"
                    name="shortcode"
                    placeholder="Type shortcode"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    value={shortcode}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        // allow only digits
                        const cleaned = e.target.value.replace(/\D/g, "");
                        setShortcode(cleaned)
                    }}
                />
                <div className="sp-form-field-error-wrapper reserved-space-error">
                    <p className="sp-form-text-error">
                        {shortcodeError}
                    </p>
                </div>
            </div>
            <div className={"feature_blog_post"}>

                <button type={"submit"} className="sp-button-secondary sp-shortcode-button">
                    Find your shortcode
                </button>
            </div>
        </form>
    </>
}

export default ShortcodeSearch